import { render, staticRenderFns } from "./modal-card.vue?vue&type=template&id=70d4de2d&scoped=true&"
import script from "./modal-card.vue?vue&type=script&lang=js&"
export * from "./modal-card.vue?vue&type=script&lang=js&"
import style0 from "./modal-card.vue?vue&type=style&index=0&id=70d4de2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d4de2d",
  null
  
)

export default component.exports